import { connect } from 'react-redux'
import PropTypes from 'prop-types'
// @ts-ignore
import {
  CompatRouter,
  useNavigationType,
  useLocation,
  Route,
  Routes,
} from 'react-router-dom-v5-compat'
import Router from 'shared/universal-router'

import ScrollToTop from 'components/scroll-to-top'

import { getBabylistButtonAdded } from '../../reducers'
import Loader from './components/loader/server-render-loader'
import SlideTransition from './components/slide-transition/slide-transition'
import AddButton from '../onboarding/components/slides/AddButton'

import RegistryType from './pages/RegistryType'
import RegistryCreate from './pages/registry-create'
import PathToParenthood from './pages/path-to-parenthood'
import ChooseTemplateFlow from './pages/ChooseTemplateFlow'
import { BirthdayFlow } from './pages/BirthdayFlow/BirthdayFlow'
import { HolidayFlow } from './pages/HolidayFlow/HolidayFlow'

import styles from './registry-builder.scss'

import { getUser } from './reducers'

export const PATHS = {
  BASE: '/registry/build',
  REGISTRY_TYPE: '/',
  // Baby Registry Paths
  ROAD_AHEAD: '/road-ahead',
  CREATE_REGISTRY: '/create',
  ADD_BUTTON: '/add-button',
  TEMPLATES: '/templates',
  BIRTHDAY_WISHLIST: '/birthday',
  HOLIDAY_WISHLIST: '/holiday',
}

// We are reusing components from onboarding which utilizes both redux and react context.
// Ideally we would only be using one of these tools
// So instead of complicating this module with both context and
// redux I opted for a simpler path wherein we treat the "context" being passed in
// as just additional props

function RegistryBuilder(props: any) {
  const { context, babylistButtonAddedEvent } = props

  const getButtonOrCreatePath = () => {
    if (context.deviceSupportsBabylistApp || babylistButtonAddedEvent) {
      return PATHS.CREATE_REGISTRY
    }

    return PATHS.ADD_BUTTON
  }

  return (
    <>
      <div className={styles.RegistryBuilder__Background} />
      <Loader>
        {/* @ts-ignore */}
        <Router basename={PATHS.BASE} location={{ pathname: PATHS.BASE }}>
          {/* this route is necessary in order for Switch to use location via props
        instead of context, which is necessary for the page transitions.
        see: https://tylermcginnis.com/react-router-animated-transitions */}
          {/* placeholder comment to create feature branch */}
          <CompatRouter>
            <Routes>
              <Route
                path="*"
                element={
                  <Slides
                    getButtonOrCreatePath={getButtonOrCreatePath}
                    bookmarkletJS={context.bookmarkletJS}
                  />
                }
              />
            </Routes>
          </CompatRouter>
        </Router>
      </Loader>
    </>
  )
}

interface SlidesProps {
  getButtonOrCreatePath: () => string
  bookmarkletJS: any
}

const Slides = ({ getButtonOrCreatePath, bookmarkletJS }: SlidesProps) => {
  const navigationType = useNavigationType()
  const location = useLocation()

  return (
    <SlideTransition
      back={navigationType === 'POP'}
      enable={navigationType !== 'REPLACE'}
    >
      <div className={styles.RegistryBuilder__Container} key={location.key}>
        <ScrollToTop>
          <Routes location={location}>
            <Route path={PATHS.REGISTRY_TYPE} element={<RegistryType />} />

            <Route
              path={`${PATHS.ROAD_AHEAD}/*`}
              element={
                // @ts-ignore
                <PathToParenthood nextPath={getButtonOrCreatePath()} />
              }
            />
            <Route
              path={`${PATHS.BIRTHDAY_WISHLIST}/*`}
              element={<BirthdayFlow />}
            />
            <Route
              path={`${PATHS.HOLIDAY_WISHLIST}/*`}
              element={<HolidayFlow />}
            />
            <Route
              path={PATHS.CREATE_REGISTRY}
              element={<RegistryCreate nextPath={PATHS.TEMPLATES} />}
            />

            <Route
              path={`${PATHS.TEMPLATES}/*`}
              element={<ChooseTemplateFlow nextPath={PATHS.BASE} />}
            />

            <Route
              path={PATHS.ADD_BUTTON}
              element={
                // @ts-ignore
                <AddButton
                  bookmarkletJS={bookmarkletJS}
                  nextPath={PATHS.CREATE_REGISTRY}
                />
              }
            />
          </Routes>
        </ScrollToTop>
      </div>
    </SlideTransition>
  )
}

RegistryBuilder.propTypes = {
  user: PropTypes.object,
  context: PropTypes.object,
}

const mapStateToProps = (state: any) => ({
  user: getUser(state),
  babylistButtonAddedEvent: getBabylistButtonAdded(state),
})

export default connect(mapStateToProps)(RegistryBuilder)
